var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.owner.article_pdf_personalizado)?_c('b-button',{staticClass:"m-l-10",attrs:{"variant":"success"},on:{"click":_vm.pdf}},[_c('i',{staticClass:"icon-list"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }